import { render, staticRenderFns } from "./DemoVideo.vue?vue&type=template&id=57477a05&scoped=true&"
import script from "./DemoVideo.vue?vue&type=script&lang=js&"
export * from "./DemoVideo.vue?vue&type=script&lang=js&"
import style0 from "./DemoVideo.vue?vue&type=style&index=0&id=57477a05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57477a05",
  null
  
)

export default component.exports